import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import styled from "styled-components";

import { InfoCircleOutlined } from "@ant-design/icons";
import { ArrowLeftColor, IConClose } from "@components";
import { PATH_HOME } from "@configs";
import { IMemberTier } from "@interfaces";
import { selectApp, selectAuth, selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { Badge, Input, Select, Switch } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { assetApi } from "src/API/asset";
import { useFullScreen } from "src/Helpers/useFullscreen";
import { deduplicate } from "src/Utils/requestDeduper";

const { Option } = Select;
interface IProps {
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

interface Car {
    assetGroupId: string;
    Id: string;
    carPlate: string;
    carPlateProvince: string;
    brand: string;
    carModel: string;
    carColor: string;
    isVIP: boolean;
    isActive: boolean;
    lastUpdated?: string;
}

export const ComponentMyParking = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    //push route
    const history = useHistory();
    const location = useLocation();
    //redux statex
    const { userInfo } = useSelector(selectAuth);
    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    const { lang } = useSelector(selectApp);
    const fullHeight = useFullScreen();

    // เพิ่ม regex สำหรับตรวจสอบป้ายทะเบียนรถ
    const licensePlateRegex = /^[1-9]?[ก-ฮ]{1,2}[0-9]{1,4}$/;

    const [isShowModalDone, setShowModalDone] = useState<boolean>(false);
    const [isShowModalError, setShowModalError] = useState<boolean>(false);
    const [isShowModalConfirm, setShowPopupConfirm] = useState<boolean>(false);

    // เพิ่มตัวแปรเก็บสถานะข้อผิดพลาดของป้ายทะเบียนรถ
    const [addLicensePlateError, setAddLicensePlateError] = useState<string>("");
    const [editLicensePlateError, setEditLicensePlateError] = useState<string>("");

    // for render UI
    const [isCreate, setIsCreate] = useState(false);
    const [isShowPopupDetail, setShowPopupDetail] = useState<boolean>(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [isOverLimit, setIsOverLimit] = useState(false);
    const [isUpdateStatus, setIsUpdateStatus] = useState(false);

    // for render VIP label
    const [isVip, setIsVip] = useState(false); // car
    const [isUserVip, setIsUserVip] = useState(false); // user

    // QR states
    const initialTime = 10 * 60;
    const [isShowQRcode, setShowQRcode] = useState<boolean>(false);
    const [timeLeft, setTimeLeft] = useState(initialTime);
    const [isTimerRunning, setIsTimerRunning] = useState(false);

    const [carsLoading, setCarsLoading] = useState(true);

    // currest asset group (for create asset into the right asset group)
    const [assetGroupID, setAssetGroupID] = useState("");

    const [tierID, setTierID] = useState(null);
    const [tierName, setTierName] = useState("");

    // car card
    const [vipCarGroupID, setVIPCarsGroupID] = useState<string>("");
    const [vipCarLimit, setVipCarLimit] = useState<number>(0);
    const [vipCars, setVIPCars] = useState<Car[]>([]);

    const [generalCarGroupID, setGeneralCarsGroupID] = useState<string>("");
    const [generalCarLimit, setGeneralCarLimit] = useState<number>(0);
    const [generalCars, setGeneralCars] = useState<Car[]>([]);

    // car form
    const [selectedCar, setSelectedCar] = useState<Car | null>(null);

    // dropdowns
    const [provinceOptions, setProvinceOptions] = useState<string[]>([]);
    const [brandOptions, setBrandOptions] = useState<string[]>([]);

    const [errorCodeFromAPI, setErrorCodeFromAPI] = useState<number>(0);
    const [errorMsgFromAPI, setErrorMsgFromAPI] = useState("");

    const [textOverlimit, setTextOverlimit] = useState("");

    const [isOverLimitCarVIP, setIsOverLimitCarVIP] = useState(false);
    const [isOverLimitCarGeneral, setIsOverLimitCarGeneral] = useState(false);

    const resetStates = () => {
        setIsVip(false);
        setShowQRcode(false);

        // setIsCreate(false);
        // setShowPopupDetail(false);
        // setIsEdit(false);
        // setIsDelete(false);
        // setIsUpdateStatus(false);

        setAddLicensePlateError("");
        setEditLicensePlateError("");
        setErrorCodeFromAPI(0);
        setErrorMsgFromAPI("");

        const emptyForm = {
            licensePlate: "",
            province: "",
            carBrand: "",
            model: "",
            color: "",
        };

        setAddFormData(emptyForm);
        setEditFormData(emptyForm);
    };

    const [addFormData, setAddFormData] = useState({
        licensePlate: "",
        province: "",
        carBrand: "",
        model: "",
        color: "",
    });
    const handleAddInputChange = (field: string, value: string) => {
        setAddFormData((prev) => ({
            ...prev,
            [field]: value,
        }));

        if (field === "licensePlate") {
            if (value && !licensePlateRegex.test(value)) {
                setAddLicensePlateError(
                    lang === "ENGLISH" ? "Invalid plate format" : "รูปแบบทะเบียนไม่ถูกต้อง"
                );
            } else {
                setAddLicensePlateError("");
            }
        }
    };

    const [editFormData, setEditFormData] = useState({
        licensePlate: "",
        province: "",
        carBrand: "",
        model: "",
        color: "",
    });
    const handleEditInputChange = (field: string, value: string) => {
        setEditFormData((prev) => ({
            ...prev,
            [field]: value,
        }));

        if (field === "licensePlate") {
            if (value && !licensePlateRegex.test(value)) {
                setEditLicensePlateError(
                    lang === "ENGLISH" ? "Invalid plate format" : "รูปแบบทะเบียนไม่ถูกต้อง"
                );
            } else {
                setEditLicensePlateError("");
                setErrorCodeFromAPI(0);
                setErrorMsgFromAPI("");
            }
        }
    };

    const resetTimer = () => {
        setTimeLeft(initialTime);
        const qrCodeContent = generateQRCodeContent();
        setQRCodeValue(qrCodeContent);
    };

    const startTimer = () => {
        setIsTimerRunning(true);
    };
    useEffect(() => {
        let timer: NodeJS.Timeout;
        if (isTimerRunning && timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft((prev) => prev - 1);
            }, 1000);
        }

        return () => {
            clearInterval(timer);
        };
    }, [isTimerRunning, timeLeft]);

    useEffect(() => {
        const fetchTierID = async () => {
            try {
                const { tierID, tierName, tags } = await getTierByUserID();
                setTierID(tierID || "empty-tier");
                setTierName(tierName);
                setIsUserVip(false);

                for (const tag of tags) {
                    if (tag.name.toUpperCase() === "VIP") {
                        setIsUserVip(true);
                    }
                }
            } catch (error) {
                console.error("Error fetching tier ID:", error);
            }
        };

        fetchTierID();
    }, [location.key, userInfo?._id]);

    useEffect(() => {
        const fetchCarsAndOptions = async () => {
            try {
                if (!tierID || !userInfo?._id) return;
                setCarsLoading(true);
                const [{ vipCars, generalCars }, { provinceOptions, brandOptions }] =
                    await Promise.all([getCarsByUserID(), getCarOptions()]);
                setVIPCars(vipCars);
                setGeneralCars(generalCars);
                setProvinceOptions(provinceOptions);
                setBrandOptions(brandOptions);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchCarsAndOptions();
    }, [tierID, userInfo?._id]);

    const formatTime = (time: number) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    };

    useEffect(() => {
        if (isShowQRcode) {
            const qrCodeContent = generateQRCodeContent();
            setQRCodeValue(qrCodeContent);
        }
    }, [isShowQRcode]);

    const generateQRCodeContent = () => {
        const now = new Date(Date.now() + 10 * 60 * 1000);
        const timeZone = "Asia/Bangkok";

        const year = String(
            new Intl.DateTimeFormat("en-GB", { year: "2-digit", timeZone }).format(now)
        ).padStart(2, "0");
        const month = String(
            new Intl.DateTimeFormat("en-GB", { month: "2-digit", timeZone }).format(now)
        ).padStart(2, "0");
        const day = String(
            new Intl.DateTimeFormat("en-GB", { day: "2-digit", timeZone }).format(now)
        ).padStart(2, "0");
        const hour = String(
            new Intl.DateTimeFormat("en-GB", { hour: "2-digit", hour12: false, timeZone }).format(
                now
            )
        ).padStart(2, "0");
        const minute = String(
            new Intl.DateTimeFormat("en-GB", { minute: "2-digit", timeZone }).format(now)
        ).padStart(2, "0");
        const second = String(
            new Intl.DateTimeFormat("en-GB", { second: "2-digit", timeZone }).format(now)
        ).padStart(2, "0");

        const formattedDate = `${year}${month}${day}${hour}${minute}${second}`;

        const qrCodeContent = `${userInfo?._id}${formattedDate}`;
        return qrCodeContent;
    };

    const [qrCodeValue, setQRCodeValue] = useState("");

    const popUpAddCar = (value: string) => {
        if (value === "VIP") {
            if (vipCars.length < vipCarLimit) {
                setAssetGroupID(vipCarGroupID);
                setIsVip(true);
                setIsCreate(true);
            }
        } else {
            if (generalCars.length < generalCarLimit) {
                setAssetGroupID(generalCarGroupID);
                setIsVip(false);
                setIsCreate(true);
            }
        }
    };

    const getCarOptions = async () => {
        try {
            if (tierID) {
                let res = await deduplicate(`asset-groups-by-tier-${tierID}`, () =>
                    assetApi.getAssetGroupsByTier(tierID)
                );
                const data = res.data.data;

                let vipGroupID = "";
                let vipCarLimit = 0;
                let generalGroupID = "";
                let generalCarLimit = 0;
                let provinceOptions: any[] = [];
                let brandOptions: any[] = [];

                for (const group of data) {
                    if (group.tags.some((tag: any) => tag.name === "VIP")) {
                        vipGroupID = group.id;
                        vipCarLimit = group.asset_limit_per_user;
                    } else {
                        generalGroupID = group.id;
                        generalCarLimit = group.asset_limit_per_user;
                    }

                    if (group.custom_fields) {
                        for (const field of group.custom_fields) {
                            if (field.slug === "car_plate_province") {
                                provinceOptions = field.options;
                            } else if (field.slug === "brand") {
                                brandOptions = field.options;
                            }

                            if (provinceOptions.length && brandOptions.length) {
                                break;
                            }
                        }
                    }
                }
                setVIPCarsGroupID(vipGroupID);
                setGeneralCarsGroupID(generalGroupID);
                setVipCarLimit(vipCarLimit);
                setGeneralCarLimit(generalCarLimit);

                return { provinceOptions, brandOptions };
            } else {
                console.error("Error: tierID null");
                return { provinceOptions: [], brandOptions: [] };
            }
        } catch (error) {
            console.error("Error fetching car options:", error);
            return { provinceOptions: [], brandOptions: [] };
        }
    };

    const checkedIsOverlimit = (vipGroup: boolean) => {
        if (vipGroup) {
            // if (vipCarLimit > vipCars.length) {
            //     setIsOverLimit(false);
            //     setShowModalDone(false);
            // } else if (vipCars.length >= 1 && vipCarLimit === 0) {
            //     setIsOverLimit(true);
            //     setShowModalDone(true);
            //     setTextOverlimit(`${vipCars.length}/${vipCarLimit}`);
            // } else if (vipCars.length === vipCars?.filter((car: any) => !car.isActive)?.length) {
            setIsOverLimit(true);
            setShowModalDone(true);
            setTextOverlimit(`${vipCars.length}/${vipCarLimit}`);
            // } else {
            //     setIsOverLimit(false);
            //     setShowModalDone(false);
            // }
        } else {
            // if (generalCarLimit > generalCars.length) {
            //     setIsOverLimit(false);
            //     setShowModalDone(false);
            // } else if (generalCars.length >= 1 && generalCarLimit === 0) {
            //     setIsOverLimit(true);
            //     setShowModalDone(true);
            //     setTextOverlimit(`${generalCars.length}/${generalCarLimit}`);
            // } else if (
            //     generalCars.length === generalCars?.filter((car: any) => !car.isActive)?.length
            // ) {
            setIsOverLimit(true);
            setShowModalDone(true);
            setTextOverlimit(`${generalCars.length}/${generalCarLimit}`);
            // } else {
            //     setIsOverLimit(false);
            //     setShowModalDone(false);
            // }
        }
    };

    const getCarsByUserID = async () => {
        try {
            const response = await deduplicate(`my-parking-cars-${userInfo?._id || ""}`, () =>
                assetApi.getCarsByUserID()
            );

            const assetGroups = response.data.data.flatMap((user: any) => user.asset_groups);

            const carData: Car[] = assetGroups.flatMap((assetGroup: any) =>
                assetGroup.assets.map((asset: any) => ({
                    Id: asset.id,
                    assetGroupId: assetGroup.id,
                    carPlate:
                        asset.custom_fields.find((field: any) => field.slug === "car_plate")
                            ?.value || "",
                    carPlateProvince:
                        asset.custom_fields.find(
                            (field: any) => field.slug === "car_plate_province"
                        )?.value || "",
                    brand:
                        asset.custom_fields.find((field: any) => field.slug === "brand")?.value ||
                        "",
                    carModel:
                        asset.custom_fields.find((field: any) => field.slug === "car_model")
                            ?.value || "",
                    carColor:
                        asset.custom_fields.find((field: any) => field.slug === "car_color")
                            ?.value || "",
                    isVIP: assetGroup.is_vip,
                    isActive: asset.is_active,
                    lastUpdated: asset.updated_at
                        ? dayjs(asset.updated_at).format("DD/MM/YYYY HH:mm")
                        : dayjs().format("DD/MM/YYYY HH:mm"),
                }))
            );

            const vipCars = carData.filter(
                (car: Car) => car.isVIP
                //  && car.assetGroupId === vipGroupID
            );
            const generalCars = carData.filter(
                (car: Car) => !car.isVIP
                // && car.assetGroupId === generalGroupID
            );

            return { vipCars, generalCars };
        } catch (err) {
            return { vipCars: [], generalCars: [] };
        } finally {
            setCarsLoading(false);
        }
    };

    const getTierByUserID = async () => {
        try {
            if (userInfo?._id) {
                const response = await assetApi.getTierByUserID(userInfo?._id || "");
                const tierID = response.data.data.tier.id;
                const tierName = response.data.data.tier.name;
                const tags = response.data.data.tags || [];

                return { tierID, tierName, tags };
            } else {
                console.error("Error: user id null");
                return { tierID: null, tierName: "", tags: [] };
            }
        } catch (error) {
            console.error("Error fetching user tier:", error);
            return { tierID: null, tierName: "", tags: [] };
        }
    };

    const AddCar = async (
        asset_group_id: string | undefined,
        formData: {
            licensePlate: string;
            province: string;
            carBrand: string;
            model: string;
            color: string;
        }
    ) => {
        try {
            let response = await assetApi.addCar(asset_group_id, formData);
            if (response.status === 200) {
                resetStates();
                setShowModalDone(true);
                getCarsByUserID().then(({ vipCars, generalCars }) => {
                    setVIPCars(vipCars);
                    setGeneralCars(generalCars);
                });
            }
        } catch (err) {
            if (axios.isAxiosError(err)) {
                setErrorMsgFromAPI(err.response?.data?.message || "An error occurred");
                setErrorCodeFromAPI(err.response?.data?.code || 0);
                if (err.response?.data?.message === "asset is duplicated") {
                    setAddLicensePlateError(
                        "Duplicate license plate number detected. Please check again.*"
                    );
                }
            } else {
                setErrorMsgFromAPI(err instanceof Error ? err.message : String(err));
                setErrorCodeFromAPI(0);
            }

            // resetStates();
            setShowModalError(true);
            return;
        }
    };

    const editCar = async (
        assetId: string,
        asset_group_id: string,
        is_active: boolean,
        formData: {
            licensePlate: string;
            province: string;
            carBrand: string;
            model: string;
            color: string;
        }
    ) => {
        try {
            let response = await assetApi.editCar(
                assetId,
                isVip ? vipCarGroupID : generalCarGroupID,
                is_active,
                formData
            );
            if (response.status === 200) {
                resetStates();
                setShowModalDone(true);
                const { vipCars, generalCars } = await getCarsByUserID();
                setVIPCars(vipCars);
                setGeneralCars(generalCars);

                const refreshedSelectedCar =
                    [...vipCars, ...generalCars].find((car) => car.Id === assetId) || null;
                setSelectedCar(refreshedSelectedCar);
            }
        } catch (err) {
            if (axios.isAxiosError(err)) {
                if (
                    err.response?.data?.message !==
                    "the number of owned assets exceeds the allowed limit"
                ) {
                    setErrorMsgFromAPI(err.response?.data?.message || "An error occurred");
                    setErrorCodeFromAPI(err.response?.data?.code || 0);
                    // resetStates();
                    setShowModalError(true);
                }
                if (err.response?.data?.message === "asset is duplicated") {
                    setEditLicensePlateError(
                        "Duplicate license plate number detected. Please check again.*"
                    );
                } else {
                    // setErrorCodeFromAPI(err.response?.data?.code || 0);
                    checkedIsOverlimit(isVip);
                    setSelectedCar({
                        ...selectedCar!,
                        isActive: !selectedCar?.isActive,
                    });
                    setIsUpdateStatus(false);
                }
            } else {
                setErrorMsgFromAPI(err instanceof Error ? err.message : String(err));
                setErrorCodeFromAPI(0);
            }

            return;
        }
    };

    const deleteCar = async (assetId: string) => {
        try {
            if (tierID) {
                let response = await assetApi.deleteCar(assetId, tierID);
                if (response.status === 200) {
                    resetStates();
                    setShowModalDone(true);
                    getCarsByUserID().then(({ vipCars, generalCars }) => {
                        setVIPCars(vipCars);
                        setGeneralCars(generalCars);
                    });
                }
            } else {
                console.error("Error: tierID null");
                return;
            }
        } catch (err) {
            if (axios.isAxiosError(err)) {
                setErrorMsgFromAPI(err.response?.data?.message || "An error occurred");
                setErrorCodeFromAPI(err.response?.data?.code || 0);
            } else {
                setErrorMsgFromAPI(err instanceof Error ? err.message : String(err));
                setErrorCodeFromAPI(0);
            }
            // resetStates();
            setShowModalError(true);
            setIsDelete(false);
            return;
        }
    };

    return (
        <>
            <RenderMeta title="My Parking" />
            <StyledMyParking
                style={{ height: fullHeight }}
                themeColor={themes?.themeColor!}
                bgImg="../../images/bg-calculator.svg"
                contentColor={merchant?.luckyDrawDisplaySetting?.textColor!}
                themePageColor="#76C0D9"
            >
                <header>
                    <div className="back-arrow">
                        <ArrowLeftColor
                            onClick={() => history.push(PATH_HOME)}
                            color={merchant?.luckyDrawDisplaySetting?.themeColor}
                        />
                    </div>
                </header>
                {/* Car Cards  */}
                <div className="wrapper-myparking">
                    <div className="show-tier-myparking">
                        <div className="my-tier">
                            {(() => {
                                switch (tierName) {
                                    case "Gold":
                                        return (
                                            <>
                                                <img
                                                    src="../../images/ic-crown-gold.png"
                                                    alt="Gold"
                                                />
                                                <span>Gold</span>
                                            </>
                                        );
                                    case "Diamond":
                                        return (
                                            <>
                                                <img
                                                    src="../../images/ic-diamond-tier.svg"
                                                    alt="Diamond"
                                                />
                                                <span>Diamond</span>
                                            </>
                                        );
                                    case "Platinum":
                                        return (
                                            <>
                                                <img
                                                    src="../../images/tier-platinum.svg"
                                                    alt="Platinum"
                                                />
                                                <span>Platinum</span>
                                            </>
                                        );
                                    default:
                                        return null;
                                }
                            })()}
                        </div>

                        <div className="ex-parking">
                            <img src="../../images/future-park/logo-parking.svg" alt="" />
                        </div>
                    </div>

                    {isUserVip ? (
                        <div className="layout-carcard-myparking">
                            {/* VIP Car Header */}
                            <div className="title-carcard-myparking">
                                <div className="group-title">
                                    <span>
                                        <img src="../../images/ic-vip.svg" alt="" />
                                    </span>
                                    <span>Exclusive Parking Pass</span>
                                </div>
                                <div
                                    className="text-addcar-myparking"
                                    style={
                                        vipCars.length === vipCarLimit
                                            ? {
                                                  color: "grey",
                                                  cursor: "not-allowed",
                                                  textShadow: "1px 0.5px 1.5px white",
                                              }
                                            : {}
                                    }
                                    onClick={() => {
                                        popUpAddCar("VIP");
                                    }}
                                >
                                    + Add vehicle {vipCars.length}/{vipCarLimit}
                                </div>
                            </div>
                            {/* VIP Car Cards */}
                            <>
                                {carsLoading ? (
                                    <p>Loading...</p>
                                ) : vipCars.length > 0 ? (
                                    <div>
                                        {vipCars.map((car) => (
                                            <div
                                                className={`static-card-myparking vip-class ${
                                                    car.isActive ? "vip-card" : "inactive-card"
                                                }`}
                                                onClick={() => {
                                                    setShowPopupDetail(true);
                                                    setIsVip(true);
                                                    setSelectedCar(car);
                                                    // getCarOptions();
                                                    // checkedIsOverlimit(true);
                                                }}
                                            >
                                                <div
                                                    className="id-card-myparking"
                                                    style={{
                                                        display: "flex",
                                                        gap: "10px",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {car.carPlate}
                                                    {!car.isActive && (
                                                        <StyledStatus active={false}>
                                                            <Badge color="#FFF" /> {"Inactive"}{" "}
                                                            <InfoCircleOutlined />
                                                        </StyledStatus>
                                                    )}
                                                </div>
                                                <div className="province-card-myparking">
                                                    {car.carPlateProvince}
                                                </div>

                                                {/* {!car.isActive && (
                                                    <div className="bubble-inactive-card">
                                                        <img
                                                            src="../../images/future-park/bubble-inactive-card.svg"
                                                            alt=""
                                                        />
                                                    </div>
                                                )} */}
                                                <div className="brand-carcard-myparking">
                                                    {car.brand}
                                                    <span className="modal">
                                                        {car.carModel} - {car.carColor}
                                                    </span>
                                                </div>
                                                <div className="icon-parking">
                                                    <img
                                                        src="../../images/ic-vip-parking.svg"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div
                                        className="add-carcard-myparking-vip"
                                        onClick={() => {
                                            popUpAddCar("VIP");
                                        }}
                                    >
                                        + Add Vehicle {vipCars.length}/{vipCarLimit}
                                    </div>
                                )}
                            </>
                        </div>
                    ) : (
                        <></>
                    )}

                    {/* General Car Header */}
                    <div className="layout-carcard-myparking">
                        <div className="title-carcard-myparking">
                            <div className="group-title">
                                <span>General Parking Pass</span>
                            </div>

                            <div
                                className="text-addcar-myparking"
                                onClick={() => {
                                    popUpAddCar("general");
                                }}
                                style={
                                    generalCars.length >= generalCarLimit
                                        ? {
                                              color: "grey",
                                              cursor: "not-allowed",
                                              textShadow: "1px 0.5px 1.5px white",
                                          }
                                        : {}
                                }
                            >
                                + Add vehicle {generalCars.length}/{generalCarLimit}
                            </div>
                        </div>

                        {/* General Car Cards */}
                        <>
                            {carsLoading ? (
                                <p>Loading...</p>
                            ) : generalCars.length > 0 ? (
                                <div>
                                    {generalCars.map((car) => (
                                        <div
                                            className={`static-card-myparking ${
                                                car.isActive ? "" : "inactive-card"
                                            }`}
                                            onClick={() => {
                                                setShowPopupDetail(true);
                                                setIsVip(false);
                                                setSelectedCar(car);
                                                // checkedIsOverlimit(false);
                                            }}
                                        >
                                            <div
                                                className="id-card-myparking"
                                                style={{
                                                    display: "flex",
                                                    gap: "10px",
                                                    alignItems: "center",
                                                }}
                                            >
                                                {car.carPlate}
                                                {!car.isActive && (
                                                    <StyledStatus active={false}>
                                                        <Badge color="#FFF" /> {"Inactive"}{" "}
                                                        <InfoCircleOutlined />
                                                    </StyledStatus>
                                                )}
                                            </div>
                                            <div className="province-card-myparking">
                                                {car.carPlateProvince}
                                            </div>
                                            {/* {!car.isActive && (
                                                <div className="bubble-inactive-card">
                                                    <img
                                                        src="../../images/future-park/bubble-inactive-card.svg"
                                                        alt=""
                                                    />
                                                </div>
                                            )} */}
                                            <div className="brand-carcard-myparking">
                                                {car.brand}
                                                <span className="modal">
                                                    {car.carModel} - {car.carColor}
                                                </span>
                                            </div>
                                            <div className="icon-parking">
                                                <img src="../../images/ic-vip-parking.svg" alt="" />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <div
                                    className="add-carcard-myparking-general"
                                    onClick={() => {
                                        popUpAddCar("general");
                                    }}
                                >
                                    + Add Vehicle {generalCars.length}/{generalCarLimit}
                                </div>
                            )}
                        </>
                    </div>
                    <div className="control-btn">
                        <StyledBtnMyParking
                            onClick={() => {
                                setShowQRcode(true);
                                startTimer();
                            }}
                        >
                            <span>
                                <img src="../../images/qr-myparking.svg" alt="" />
                            </span>
                            Show my QR Code
                        </StyledBtnMyParking>
                    </div>
                </div>

                {/* Detail Popup */}
                {isShowPopupDetail && (
                    <StyledShowPopup themeColor={themes?.themeColor!}>
                        <div className="page-wrapper">
                            <div
                                className="close"
                                onClick={() => {
                                    setShowPopupDetail(false);
                                    resetStates();
                                }}
                            >
                                <IConClose width={16} />
                            </div>
                            <div className="content-layout">
                                <div className="header-parking-edit">
                                    <div className="title-edit">Vehicle Details</div>
                                    <div className="option-edit">
                                        <div
                                            className="delete-edit"
                                            onClick={() => {
                                                setShowPopupConfirm(true);
                                                setIsDelete(true);
                                            }}
                                        >
                                            Delete
                                        </div>
                                        <div
                                            className="edit-edit"
                                            onClick={() => {
                                                setIsEdit(true);
                                                setEditFormData({
                                                    licensePlate: selectedCar?.carPlate || "",
                                                    province: selectedCar?.carPlateProvince || "",
                                                    carBrand: selectedCar?.brand || "",
                                                    model: selectedCar?.carModel || "",
                                                    color: selectedCar?.carColor || "",
                                                });
                                            }}
                                        >
                                            <span>
                                                <img
                                                    src="../../images/ic-edit-parking.svg"
                                                    alt=""
                                                />
                                            </span>
                                            Edit
                                        </div>
                                    </div>
                                </div>
                                {!selectedCar?.isActive && (
                                    <div className="layout-detail-edit-parking">
                                        <div
                                            className="layout-edit-parking"
                                            style={{
                                                display: "flex",
                                                gap: "10px",
                                                alignItems: "baseline",
                                            }}
                                        >
                                            <InfoCircleOutlined />
                                            <p style={{ lineHeight: "20px" }}>
                                                {
                                                    "Due to an update in the points accumulation conditions, your accumulated points no longer meet the retention criteria. As a result, the number of vehicles eligible for parking has been adjusted."
                                                }
                                            </p>
                                        </div>
                                    </div>
                                )}
                                <div className="layout-detail-edit-parking">
                                    <div className="layout-edit-parking">
                                        <div className="title-edit-parking">License plate</div>
                                        <div className="detail-edit-parking-carplate">
                                            {selectedCar?.isVIP && (
                                                <span>
                                                    <img src="../../images/ic-vip.svg" alt="" />
                                                </span>
                                            )}
                                            {selectedCar?.carPlate}
                                        </div>
                                    </div>
                                    <div className="layout-edit-parking">
                                        <div className="title-edit-parking">Province</div>
                                        <div className="detail-edit-parking">
                                            {selectedCar?.carPlateProvince}
                                        </div>
                                    </div>
                                    <div className="layout-edit-parking">
                                        <div className="title-edit-parking">Brand</div>
                                        <div className="detail-edit-parking">
                                            {selectedCar?.brand} {selectedCar?.carModel} -{" "}
                                            {selectedCar?.carColor}
                                        </div>
                                    </div>
                                    <div className="layout-edit-parking">
                                        <div className="title-edit-parking">Status</div>
                                        <div className="detail-edit-parking-status">
                                            <>
                                                <StyledStatus
                                                    active={selectedCar?.isActive ? true : false}
                                                >
                                                    <Badge
                                                        color={
                                                            selectedCar?.isActive
                                                                ? themes?.themeColor
                                                                : "#FFF"
                                                        }
                                                    />
                                                    <p
                                                        style={{
                                                            color: selectedCar?.isActive
                                                                ? "#000"
                                                                : "#FFF",
                                                        }}
                                                    >
                                                        {selectedCar?.isActive
                                                            ? "Active"
                                                            : "Inactive"}
                                                    </p>
                                                    {!selectedCar?.isActive && (
                                                        <InfoCircleOutlined
                                                            style={{
                                                                color: "#FFF",
                                                            }}
                                                        />
                                                    )}
                                                </StyledStatus>
                                                <Switch
                                                    checked={selectedCar?.isActive}
                                                    onChange={(e: boolean) => {
                                                        setIsUpdateStatus(true);
                                                        setSelectedCar({
                                                            ...selectedCar!,
                                                            isActive: e,
                                                        });
                                                        setShowPopupConfirm(true);
                                                    }}
                                                    style={{
                                                        background: selectedCar?.isActive
                                                            ? themes?.themeColor
                                                            : "",
                                                    }}
                                                    disabled={
                                                        isOverLimitCarGeneral || isOverLimitCarVIP
                                                        // ||
                                                        // (selectedCar?.isVIP
                                                        //     ? generalCarLimit === 0
                                                        //     : vipCarLimit === 0)
                                                    }
                                                />
                                            </>
                                        </div>
                                    </div>
                                    <div className="layout-edit-parking">
                                        <div className="title-edit-parking">Last Updated</div>
                                        <div className="detail-edit-parking">
                                            {selectedCar?.lastUpdated ||
                                                dayjs().format("DD/MM/YYYY HH:mm")}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </StyledShowPopup>
                )}

                {/* Create Popup */}
                {isCreate && (
                    <StyledShowPopup themeColor={themes?.themeColor!}>
                        <div className="page-wrapper">
                            <div
                                className="close"
                                onClick={() => {
                                    setIsCreate(false);
                                    setEditLicensePlateError("");
                                    resetStates();
                                }}
                            >
                                <IConClose width={16} />
                            </div>
                            <div className="content-layout">
                                <div className="header-form-parking">
                                    {themes?.logoSmallUrl ? (
                                        <img
                                            src={themes?.logoSmallUrl}
                                            alt=""
                                            width={52}
                                            height={48}
                                        />
                                    ) : (
                                        <img src="../../images/logo-futurepark-color.svg" alt="" />
                                    )}
                                    Register Vehicle
                                    {isVip && (
                                        <span>
                                            <img src="../../images/ic-vip.svg" alt="" />
                                        </span>
                                    )}
                                </div>
                                <div className="layout-form-booking">
                                    <div className="input-survey-detail">
                                        <p className="input-title">License plate</p>
                                        <Input
                                            className={`survey-input ${
                                                addLicensePlateError ? "error-input" : ""
                                            }`}
                                            onChange={(e) =>
                                                handleAddInputChange("licensePlate", e.target.value)
                                            }
                                        />
                                        {addLicensePlateError && (
                                            <p className="error-message">{addLicensePlateError}</p>
                                        )}
                                    </div>
                                    <div className="input-survey-detail">
                                        <p className="input-title">Province</p>

                                        <Select
                                            suffixIcon={true}
                                            onChange={(value) =>
                                                handleAddInputChange("province", value)
                                            }
                                        >
                                            {provinceOptions.map((option: string) => (
                                                <Option key={option} value={option}>
                                                    {option}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                    <div className="input-survey-detail">
                                        <p className="input-title">Car Brand</p>
                                        <Select
                                            suffixIcon={true}
                                            onChange={(value) =>
                                                handleAddInputChange("carBrand", value)
                                            }
                                        >
                                            {brandOptions.map((option: string) => (
                                                <Option key={option} value={option}>
                                                    {option}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                    <div className="input-survey-detail">
                                        <p className="input-title">Model</p>
                                        <Input
                                            className="survey-input"
                                            onChange={(e) =>
                                                handleAddInputChange("model", e.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="input-survey-detail">
                                        <p className="input-title">Color</p>
                                        <Input
                                            className="survey-input"
                                            onChange={(e) =>
                                                handleAddInputChange("color", e.target.value)
                                            }
                                        />
                                    </div>
                                    <StyledBtnConfirm
                                        disabled={
                                            !addFormData.licensePlate ||
                                            !addFormData.province ||
                                            !addFormData.carBrand ||
                                            !addFormData.model ||
                                            !addFormData.color ||
                                            addLicensePlateError !== ""
                                        }
                                        onClick={() => {
                                            setAddFormData({
                                                licensePlate: addFormData.licensePlate,
                                                province: addFormData.province,
                                                carBrand: addFormData.carBrand,
                                                model: addFormData.model,
                                                color: addFormData.color,
                                            });
                                            setShowPopupConfirm(true);
                                        }}
                                    >
                                        Confirm
                                    </StyledBtnConfirm>
                                </div>
                            </div>
                        </div>
                    </StyledShowPopup>
                )}

                {/* Edit Popup */}
                {isEdit && (
                    <StyledShowPopup themeColor={themes?.themeColor!}>
                        <div className="page-wrapper">
                            <div
                                className="close"
                                onClick={() => {
                                    setIsEdit(false);
                                    setEditLicensePlateError("");
                                }}
                            >
                                <IConClose width={16} />
                            </div>
                            <div className="content-layout">
                                <div className="header-form-parking">
                                    {themes?.logoSmallUrl ? (
                                        <img
                                            src={themes?.logoSmallUrl}
                                            alt=""
                                            width={52}
                                            height={48}
                                        />
                                    ) : (
                                        <img src="../../images/logo-futurepark-color.svg" alt="" />
                                    )}
                                    Edit Vehicle
                                    {isVip && (
                                        <span>
                                            <img src="../../images/ic-vip.svg" alt="" />
                                        </span>
                                    )}
                                </div>
                                <div className="layout-form-booking">
                                    <div className="input-survey-detail">
                                        <p className="input-title">License plate</p>
                                        <Input
                                            className={`survey-input ${
                                                editLicensePlateError ? "error-input" : ""
                                            }`}
                                            defaultValue={editFormData?.licensePlate}
                                            onChange={(e) =>
                                                handleEditInputChange(
                                                    "licensePlate",
                                                    e.target.value
                                                )
                                            }
                                        />
                                        {editLicensePlateError && (
                                            <p className="error-message">{editLicensePlateError}</p>
                                        )}
                                    </div>
                                    <div className="input-survey-detail">
                                        <p className="input-title">Province</p>
                                        <Select
                                            suffixIcon={true}
                                            defaultValue={editFormData?.province}
                                            onChange={(value) =>
                                                handleEditInputChange("province", value)
                                            }
                                        >
                                            {provinceOptions.map((option: string) => (
                                                <Option key={option} value={option}>
                                                    {option}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                    <div className="input-survey-detail">
                                        <p className="input-title">Car Brand</p>
                                        <Select
                                            suffixIcon={true}
                                            defaultValue={editFormData?.carBrand}
                                            onChange={(value) =>
                                                handleEditInputChange("carBrand", value)
                                            }
                                        >
                                            {brandOptions.map((option: string) => (
                                                <Option key={option} value={option}>
                                                    {option}
                                                </Option>
                                            ))}
                                        </Select>
                                    </div>
                                    <div className="input-survey-detail">
                                        <p className="input-title">Model</p>
                                        <Input
                                            className="survey-input"
                                            defaultValue={editFormData?.model}
                                            onChange={(e) =>
                                                handleEditInputChange("model", e.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="input-survey-detail">
                                        <p className="input-title">Color</p>
                                        <Input
                                            className="survey-input"
                                            defaultValue={editFormData?.color}
                                            onChange={(e) =>
                                                handleEditInputChange("color", e.target.value)
                                            }
                                        />
                                    </div>
                                    <div className="edit-sub-text">
                                        **Updates or modifications to vehicle registration
                                        information will take effect on the following day.
                                    </div>
                                    <StyledBtnConfirm
                                        disabled={
                                            !editFormData.licensePlate ||
                                            !editFormData.province ||
                                            !editFormData.carBrand ||
                                            !editFormData.model ||
                                            !editFormData.color ||
                                            editLicensePlateError !== ""
                                        }
                                        onClick={() => {
                                            setShowPopupConfirm(true);
                                            setIsEdit(true);
                                        }}
                                    >
                                        Confirm
                                    </StyledBtnConfirm>
                                </div>
                            </div>
                        </div>
                    </StyledShowPopup>
                )}

                {isShowModalConfirm && (
                    <StyledPopupConfirm
                        themeColor={themes?.themeColor!}
                        onClick={() => {
                            setShowPopupConfirm(false);
                            if (isOverLimit) {
                                setShowPopupConfirm(false), setIsOverLimit(false);
                            }
                        }}
                    >
                        <div className="box-popupconfirm">
                            <div className="title">
                                <div className="text-sub-header">
                                    {(() => {
                                        switch (true) {
                                            case isDelete:
                                                return (
                                                    <>
                                                        Do you want to delete vehicle?
                                                        <span style={{ color: "#000" }}>
                                                            If you confirm to delete, This can't be
                                                            undone.
                                                        </span>
                                                    </>
                                                );
                                            case isEdit:
                                                return (
                                                    <>
                                                        Confirm Edit vehicle
                                                        <span style={{ color: "#000" }}>
                                                            Please wait for the verification of your
                                                            vehicle registration information within
                                                            24 hours.
                                                        </span>
                                                    </>
                                                );
                                            case isUpdateStatus:
                                                return (
                                                    <>
                                                        Confirm update Status vehicle
                                                        <span style={{ color: "#000" }}>
                                                            Please wait for the verification of your
                                                            vehicle registration information within
                                                            24 hours.
                                                        </span>
                                                    </>
                                                );
                                            default:
                                                return (
                                                    <>
                                                        Confirm Register vehicle
                                                        <span style={{ color: "#000" }}>
                                                            Please wait for the verification of your
                                                            vehicle registration information within
                                                            24 hours.
                                                        </span>
                                                    </>
                                                );
                                        }
                                    })()}
                                </div>
                            </div>
                            <div className="btn-popupconfirm">
                                <StyledUsedBtn
                                    className="btn-cancel"
                                    themeColor={themes?.themeColor!}
                                    onClick={() => {
                                        setShowPopupConfirm(false);
                                        setIsDelete(false);
                                        if (isUpdateStatus) {
                                            setIsUpdateStatus(false);
                                            setSelectedCar({
                                                ...selectedCar!,
                                                isActive: !selectedCar?.isActive,
                                            });
                                        }
                                    }}
                                >
                                    {t("page.cancel")}
                                </StyledUsedBtn>
                                {(() => {
                                    switch (true) {
                                        case isDelete:
                                            return (
                                                <StyledBtnConfirm
                                                    disabled={false}
                                                    className="btn-delete"
                                                    onClick={() => {
                                                        if (selectedCar?.Id) {
                                                            deleteCar(selectedCar.Id);
                                                        }
                                                        setShowPopupConfirm(false);
                                                    }}
                                                >
                                                    {t("page.confirm")}
                                                </StyledBtnConfirm>
                                            );
                                        case isEdit:
                                            return (
                                                <StyledBtnConfirm
                                                    disabled={false}
                                                    onClick={() => {
                                                        if (
                                                            selectedCar?.Id &&
                                                            selectedCar?.assetGroupId
                                                        ) {
                                                            editCar(
                                                                selectedCar.Id,
                                                                selectedCar.assetGroupId,
                                                                selectedCar.isActive,
                                                                editFormData
                                                            );
                                                        }
                                                        setShowPopupConfirm(false);
                                                    }}
                                                >
                                                    {t("page.confirm")}
                                                </StyledBtnConfirm>
                                            );
                                        case isUpdateStatus:
                                            return (
                                                <StyledBtnConfirm
                                                    disabled={false}
                                                    onClick={() => {
                                                        if (selectedCar) {
                                                            editCar(
                                                                selectedCar.Id,
                                                                selectedCar.assetGroupId,
                                                                selectedCar.isActive,
                                                                {
                                                                    licensePlate:
                                                                        selectedCar.carPlate,
                                                                    province:
                                                                        selectedCar.carPlateProvince,
                                                                    carBrand: selectedCar.brand,
                                                                    model: selectedCar.carModel,
                                                                    color: selectedCar.carColor,
                                                                }
                                                            );
                                                        }
                                                        setShowPopupConfirm(false);
                                                    }}
                                                >
                                                    {t("page.confirm")}
                                                </StyledBtnConfirm>
                                            );
                                        default:
                                            return (
                                                <StyledBtnConfirm
                                                    disabled={false}
                                                    onClick={() => {
                                                        AddCar(assetGroupID, addFormData);
                                                        setShowPopupConfirm(false);
                                                    }}
                                                >
                                                    {t("page.confirm")}
                                                </StyledBtnConfirm>
                                            );
                                    }
                                })()}
                            </div>
                        </div>
                    </StyledPopupConfirm>
                )}

                {isShowModalDone && (
                    <StyledPopupDone
                        themeColor={themes?.themeColor!}
                        onClick={() => {
                            if (isCreate) {
                                setIsCreate(false);
                                setShowModalDone(false);
                            } else if (isEdit) {
                                setIsEdit(false);
                                setShowPopupDetail(true);
                                setShowModalDone(false);
                            } else if (isDelete) {
                                setIsDelete(false);
                                setShowPopupDetail(false);
                                setShowModalDone(false);
                                resetStates();
                            } else if (isUpdateStatus) {
                                setIsUpdateStatus(false);
                                setShowModalDone(false);
                            } else if (isOverLimit) {
                                setIsOverLimit(false);
                                setShowModalDone(false);
                            } else {
                                resetStates();
                                setShowModalDone(false);
                            }
                        }}
                    >
                        <div className="box-popupdone" onClick={(e) => e.stopPropagation()}>
                            {(isCreate || isEdit || isUpdateStatus || isDelete) && (
                                <div className="img-parking-done">
                                    <img src="../../images/parking-done.svg" alt="" />
                                </div>
                            )}
                            <div className="title">
                                {(() => {
                                    switch (true) {
                                        case isDelete:
                                            return (
                                                <div className="text-sub-header">
                                                    Delete vehicle success
                                                </div>
                                            );
                                        case isEdit:
                                            return (
                                                <div className="text-sub-header">
                                                    Confirm edit vehicle success
                                                    <span style={{ color: "#000" }}>
                                                        Please wait for the verification of your
                                                        vehicle registration information within 24
                                                        hours.
                                                    </span>
                                                </div>
                                            );
                                        case isUpdateStatus:
                                            return (
                                                <div className="text-sub-header">
                                                    Confirm edit status vehicle success
                                                    <span style={{ color: "#000" }}>
                                                        Please wait for the verification of your
                                                        vehicle registration information within 24
                                                        hours.
                                                    </span>
                                                </div>
                                            );
                                        case isOverLimit:
                                            return (
                                                <div className="text-sub-header">
                                                    <InfoCircleOutlined
                                                        style={{
                                                            color: "red",
                                                            fontSize: "24px",
                                                            paddingBottom: "12px",
                                                        }}
                                                    />
                                                    <h5>
                                                        <b>
                                                            Vehicle Limit Reached (
                                                            {`${textOverlimit}`})
                                                        </b>
                                                    </h5>
                                                    <span style={{ color: "#000" }}>
                                                        Please deactivate one of your currently
                                                        active vehicles first to free up a slot,
                                                        then you can activate this vehicle.
                                                    </span>
                                                </div>
                                            );
                                        default:
                                            return (
                                                <div className="text-sub-header">
                                                    Confirm register vehicle success
                                                    <span style={{ color: "#000" }}>
                                                        Please wait for the verification of your
                                                        vehicle registration information within 24
                                                        hours.
                                                    </span>
                                                </div>
                                            );
                                    }
                                })()}
                            </div>
                        </div>
                    </StyledPopupDone>
                )}

                {isShowModalError && (
                    <StyledPopupDone
                        themeColor={themes?.themeColor!}
                        onClick={() => {
                            setShowModalError(false);
                        }}
                    >
                        <div className="box-popupdone" onClick={(e) => e.stopPropagation()}>
                            <div className="title">
                                <div className="text-sub-header">
                                    {(() => {
                                        switch (errorCodeFromAPI) {
                                            case -2003:
                                                return "ทะเบียนนี้มีการลงทะเบียนแล้ว";
                                            case -5000:
                                                return "the number of owned assets exceeds the allowed limit";
                                            default:
                                                return "ระบบขัดเกิดข้อผิดพลาด";
                                        }
                                    })()}
                                </div>
                            </div>
                        </div>
                    </StyledPopupDone>
                )}

                {isShowQRcode &&
                    tierName !== "Gold" &&
                    (vipCars.length > 0 || generalCars.length > 0) && (
                        <StyledShowPopup themeColor={themes?.themeColor!}>
                            <div className="page-wrapper">
                                <div className="close" onClick={resetStates}>
                                    <IConClose width={16} />
                                </div>
                                <div className="content-layout">
                                    <div className="layout-qrcode">
                                        <div className="title-qrcode">
                                            Show QR code for entrance parking
                                        </div>
                                        <div className="show-qrcode">
                                            <QRCode value={qrCodeValue} size={200} />
                                        </div>
                                        <div className="countdown-qrcode">
                                            <span onClick={resetTimer}>
                                                <img src="../../images/ic-countdown.svg" alt="" />
                                            </span>
                                            {formatTime(timeLeft)}
                                        </div>
                                        <div className="text-countdown-qrcode">
                                            Please show this screen or capture this screen and
                                            present them to the merchant
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </StyledShowPopup>
                    )}
            </StyledMyParking>
        </>
    );
};

const StyledPopupDone = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 11;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupdone {
        background: ${(p) => p.theme.colors.card};
        padding: 28px 28px;
        border-radius: 8px;
        width: calc(85% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-parking-done {
            margin-bottom: 16px;
            text-align: center;
            img {
                width: 64px;
                height: 64px;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        text-align: center;
        .text-sub-header {
            font-size: 18px;
            line-height: 21px;
            color: #000;
            font-weight: 600;
            span {
                font-size: 11px;
                line-height: 14px;
                display: block;
                color: #9b9b9b;
                margin-top: 10px;
            }
        }
    }
`;

const StyledPopupConfirm = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 11;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    .box-popupconfirm {
        background: ${(p) => p.theme.colors.card};
        padding: 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .btn-popupconfirm {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
            .btn-redeem {
                color: #fff;
                background-color: ${(p) => p.themeColor};
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
                font-weight: 600;
            }
            .btn-delete {
                color: #fff;
                background-color: #db1212;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
                font-weight: 600;
            }
            .btn-cancel {
                color: #000;
                background-color: #fff;
                border: 1px solid #e1e1e1;
                width: 100%;
                padding: 10px 0;
                font-size: 13px;
            }
        }
    }
    .title {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        justify-content: center;
        text-align: center;
        .text-sub-header {
            font-size: 18px;
            line-height: 21px;
            color: #000;
            font-weight: 600;
            span {
                font-size: 11px;
                line-height: 14px;
                display: block;
                color: #9b9b9b;
                margin-top: 10px;
            }
        }
    }
`;

const StyledUsedBtn = styled.button<{ themeColor: string }>`
    padding: 3px 12px;
    color: ${(p) => p.themeColor};
    background: ${(p) => p.theme.colors.card};
    border: 0.5px solid ${(p) => p.themeColor};
    border-radius: 40px;
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    &:active {
        background: ${(p) => p.themeColor};
        color: ${(p) => p.theme.colors.color};
    }
`;

const StyledBtnConfirm = styled.button<{ disabled: boolean }>`
    z-index: 0;
    padding: 14.5px 32px;
    border-radius: 12px;
    background-color: ${(props) => (props.disabled ? "#E1E1E1" : "#CAD51C")};
    color: #fff;
    text-align: center;
    border: none;
    width: 100%;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;

const StyledBtnMyParking = styled.button`
    padding: 14.5px 32px;
    border-radius: 12px;
    background-color: #cad51c;
    color: #fff;
    text-align: center;
    border: none;
    margin-top: 30px;
    span {
        position: relative;
        top: 3px;
        margin-right: 10px;
        img {
            width: 16px;
            height: 16px;
        }
    }
`;

const StyledShowPopup = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    flex-direction: column;
    justify-content: end;
    transition: 2s !important;
    animation: opacity 0.5s !important;
    @keyframes opacity {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
    .header-parking-edit {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        padding-top: 30px;
        margin-bottom: 20px;
        .title-edit {
            font-size: 14px;
            font-weight: 600;
            color: #000;
        }
        .option-edit {
            display: flex;
            gap: 30px;
            .delete-edit {
                font-size: 14px;
                line-height: 20px;
                color: #000514;
                position: relative;
                &:after {
                    position: absolute;
                    content: "";
                    width: 1px;
                    height: 13px;
                    background-color: #a2a2a1;
                    right: -15px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
            .edit-edit {
                font-size: 14px;
                line-height: 20px;
                color: #000514;
                span {
                    margin-right: 5px;
                    img {
                        width: 12px;
                        height: 12px;
                    }
                }
            }
        }
    }
    .layout-detail-edit-parking {
        padding: 8px 16px;
        margin-bottom: 30px;
        background-color: #f9f9f9;
        border-radius: 8px;
        .layout-edit-parking {
            padding: 12px 0px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #e1e1e1;
            &:last-child {
                border-bottom: none;
            }
            .title-edit-parking {
                font-size: 14px;
            }
            .detail-edit-parking {
                font-size: 14px;
                display: flex;
                gap: 10px;
                -webkit-box-align: center;
                text-align: right;
                width: 200px;
                justify-content: flex-end;
                span {
                    width: auto;
                    height: 18px;
                }
            }
            .detail-edit-parking-carplate {
                font-size: 20px;
                font-weight: 600;
            }
            .detail-edit-parking-status {
                font-size: 14px;
                display: flex;
                gap: 10px;
                -webkit-box-align: center;
                text-align: right;
                width: 200px;
                justify-content: flex-end;
            }
        }
    }
    .topic-popup-product {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        position: relative;
        justify-content: center;
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .header {
        width: 100%;
        padding: 16px 24px;
        background: ${(p) => p.theme.colors.card};
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px 8px 0px 0px;
        color: inherit;
        animation: bottomtotop 0.5s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .close {
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
    }
    .page-wrapper {
        position: relative;
        width: 100%;

        overflow-y: scroll;
        border-radius: 20px 20px 20px 20px;
        background: #ffffff;

        padding-bottom: 80px;

        .close {
            position: absolute;
            right: 18px;
            top: 18px;
            z-index: 1;
        }
    }
    .form-content-product {
        border-radius: 6px;
        margin-bottom: 10px;
        .title {
            font-size: 16px;
            color: #676767;
            margin: 10px 0;
        }
    }
    .ant-select {
        width: 100%;
    }
    .ant-select-selection {
        border-color: #d9d9d9 !important;
        // box-shadow: none !important;
        height: 48px;
        font-size: 16px;
        color: inherit;
        display: flex;
        flex-direction: column;
        justify-content: center;
        background-color: #fff;
        /* margin-bottom: 27px; */
        border-radius: 6px;
    }
    .content-layout-fullpage {
        height: 100vh;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #f2e8d7;
        padding-top: 24px;
        padding-bottom: 24px;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        @media (max-width: ${(p) => p.theme.breakPoints.breakMobileMax}) {
            overflow: scroll;
        }
        .topic-page {
            font-size: 20px;
            text-align: center;
            color: #000;
            font-weight: 600;
        }
    }
    .content-fullpage {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        top: 50%;
        transform: translateY(-52%);
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            border-radius: 16px;
            padding: 20px;
        }
        .btn-redeem {
            color: #fff;
            background-color: ${(p) => p.themeColor};
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
        }
        .header-product {
            // border-bottom: 1px solid #F0F0F0;
            padding: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    background-color: #ddd;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
                word-break: break-all;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
        }
        .content-product {
            padding: 16px;
            margin-bottom: 50px;
            text-align: center;
            .topic-detail {
                text-align: center;
                color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #9b9b9b;
                margin-bottom: 16px;
            }
        }
        .interception {
            width: 100%;
            // border-bottom: 5px dotted ${(p) => p.theme.colors.cutter};
            border-bottom: 5px dotted #eaeeff;
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                // background: ${(p) => p.theme.colors.cutter};
                background-color: #f2e8d7;
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #fff;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 10px;
                line-height: 14px;
                text-align: center;
                color: #000000;
            }
        }
    }
    .content-layout {
        height: auto;
        // background: ${(p) => p.theme.colors.cutter};
        background-color: #fff;
        /* padding-top: 24px;
        padding-bottom: 24px; */
        padding: 24px;
        width: 100%;
        animation: bottomtotop 0.5s !important;
        position: relative;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        @keyframes bottomtotop {
            0% {
                top: 100%;
            }
            80% {
                top: -5%;
            }
            100% {
                top: 0%;
            }
        }
        .edit-sub-text {
            font-size: 14px;
            line-height: 17px;
            text-align: center;
            color: #f2a808;
            margin-bottom: 12px;
        }
        .layout-qrcode {
            padding: 30px 0 60px;
            .title-qrcode {
                text-align: center;
                font-size: 16px;
                font-weight: 600;
                color: #000;
                margin-bottom: 16px;
            }
            .show-qrcode {
                margin-bottom: 10px;
                text-align: center;
            }
            .countdown-qrcode {
                margin-bottom: 10px;
                font-size: 12px;
                line-height: 15px;
                color: #db1212;
                text-align: center;
                span {
                    margin-right: 5px;
                    position: relative;
                    top: 3px;
                }
            }
            .text-countdown-qrcode {
                font-size: 14px;
                line-height: 17px;
                color: #9b9b9b;
                text-align: center;
            }
        }
        .input-survey-detail {
            margin-bottom: 30px;
            .input-title {
                font-size: 14px;
                line-height: 17px;
                color: #000;
                margin-bottom: 5px;
            }

            .ant-select {
                width: 100%;
                .ant-select-selection {
                    box-shadow: none !important;
                    height: 65px;
                    font-size: 14px;
                    color: ${(p) => p.themeColor};
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    border-radius: 16px;
                    width: 100%;
                    background-color: ${(p) => p.theme.colors.card};
                    border: 1px solid ${(p) => p.themeColor};
                    cursor: default;
                }
                .ant-select-arrow {
                    color: ${(p) => p.themeColor};
                }
            }
        }
        .survey-input {
            box-shadow: none !important;
            height: 65px;
            font-size: 14px;
            color: ${(p) => p.themeColor};
            display: flex;
            flex-direction: column;
            justify-content: center;
            border-radius: 16px;
            width: 100%;
            background-color: ${(p) => p.theme.colors.card};
            /* border: 1px solid ${(p) => p.themeColor}; */
            cursor: default;
        }
        .ant-select-selection--multiple {
            .ant-select-arrow {
                margin-top: 10px;
                top: 8px;
            }
        }
        .header-form-parking {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 30px;
        }
        .content {
            background: transparent !important;
        }
        .btn-redeem {
            color: #fff;
            background-color: ${(p) => p.themeColor};
            width: 100%;
            padding: 10px 0;
            font-size: 13px;
            // background-color: lightgray;
            // border-color: lightgray;
        }
        .header-product {
            border-bottom: 1px solid #f0f0f0;
            margin-bottom: 20px;
            margin-top: -100px;
            padding-bottom: 20px;
            .layout-img {
                text-align: center;
                .img-product {
                    width: 141px;
                    height: 141px;
                    border-radius: 100%;
                    overflow: hidden;
                    margin: 0 auto 20px;
                    background-color: #ddd;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }
            }
            .topic-product {
                text-align: center;
                font-weight: 600;
                color: #000;
                font-size: 18px;
                line-height: 22px;
                margin-bottom: 5px;
            }
            .total-point-product {
                text-align: center;
                color: #c4a363;
                font-size: 14px;
                margin-bottom: 5px;
            }
            .point-product {
                text-align: center;
                margin-bottom: 5px;
                span {
                    margin-right: 5px;
                }
            }
            .expier-product {
                text-align: center;
                color: #9b9b9b;
            }
            .process-product {
                max-width: 200px;
                margin: 10px auto;
                .ant-progress-inner {
                }
                .ant-progress-bg {
                    background-color: ${(p) => p.themeColor};
                }
            }
        }
        .content-product {
            margin-bottom: 50px;
            .topic-detail {
                text-align: left;
                color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                margin-bottom: 10px;
            }
            .layout-giftset {
                padding: 12px;
                background-color: rgba(51, 108, 81, 0.08);
                border-radius: 12px;
                position: relative;
                padding-left: 80px;
                margin-bottom: 15px;
                .img-giftset {
                    position: absolute;
                    top: 50%;
                    left: 12px;
                    transform: translateY(-50%);
                    img {
                        width: 52px;
                        height: 52px;
                        object-fit: contain;
                    }
                }
                .text-giftset {
                    h2 {
                        font-size: 14px;
                        line-height: 17px;
                        color: #000;
                        font-weight: 600;
                        word-break: break-all;
                    }
                    p {
                        font-size: 12px;
                        line-height: 16px;
                        margin-bottom: 0;
                        color: #525257;
                        min-height: 30px;
                        word-break: break-word;
                    }
                }
            }
            p {
                font-size: 12px;
                color: #9b9b9b;
                color: red;
            }
        }
    }
    .content {
        width: calc(100% - 48px);
        padding-bottom: 28px;
        background: ${(p) => p.theme.colors.card};
        position: relative;
        border-radius: 16px;
        bottom: 0;
        margin: auto;
        padding-bottom: 0;
        .close {
            position: absolute;
            top: 20px;
            right: 20px;
            cursor: pointer;
            transform: rotate(0deg);
            transition: 0.6s;
            &:hover {
                transform: rotate(90deg);
            }
        }
        .content-info {
            padding: 10px;
        }
        .countdownBox {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .interception {
            width: 100%;
            border-bottom: 7px dotted ${(p) => p.theme.colors.cutter};
            margin-bottom: 5px;
            position: relative;
            display: flex;
            justify-content: space-between;
            .cutter {
                width: 24px;
                height: 24px;
                background: ${(p) => p.theme.colors.cutter};
                border-radius: 12px;
                &.left {
                    position: absolute;
                    left: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
                &.right {
                    position: absolute;
                    right: -14px;
                    bottom: -13px;
                    z-index: 2;
                }
            }
            .middle-cutter {
                height: 9px;
                width: 100%;
                background: #f8eff0;
                position: absolute;
                bottom: -12px;
                right: 0px;
                border-top-left-radius: 13px;
            }
        }
        .action-layout {
            padding: 8px 24px 24px 24px;
            // background: #f8eff0;
            border-bottom-left-radius: 24px;
            border-bottom-right-radius: 24px;
            .qr-layout {
                padding: 16px;
                display: flex;
                justify-content: center;
                position: relative;
                margin-bottom: 16px;
                .qr-box {
                    padding: 24px;
                    background: #fff;
                    border-radius: 16px;
                    filter: drop-shadow(0px 3px 12px rgba(143, 143, 143, 0.38));
                }
                .code-btn {
                }
            }
            .code-qr {
                font-weight: 700;
                font-size: 20px;
                line-height: 24px;
                color: #000;
                text-align: center;
            }
            .redeemed-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .pending-product {
                text-align: center;
                font-size: 12px;
                color: #ed773a;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .used-product {
                text-align: center;
                font-size: 12px;
                color: #336c51;
                line-height: 14px;
                span {
                    margin-right: 5px;
                }
            }
            .note {
                font-style: normal;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #9b9b9b;
            }
        }
        .disabled {
            background-color: #e1e1e1;
            border-color: #e1e1e1;
        }
    }
    .title {
        line-height: 19px;
        color: ${(p) => p.theme.colors.color};
    }
    .desc {
        color: ${(p) => p.theme.colors.color};
        margin-bottom: 16px;
    }
    .desConfirm {
        width: 100%;
        margin-top: 24px;
        text-align: center;
    }
    .confirm-btn-layout {
        margin-top: 100px;
    }
    .btnLayout {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .error-input {
        border-color: #db1212 !important;
    }

    .error-message {
        color: #db1212;
        font-size: 12px;
        margin-top: 5px;
    }
`;

const StyledMyParking = styled.div<{
    themeColor: string;
    bgImg: string;
    contentColor: string;
    themePageColor: string;
}>`
    width: 100%;
    margin: 0 auto;
    height: 100vh;
    overflow: scroll;
    background-color: #76c0d9;
    background-position: center top;
    background-repeat: no-repeat;
    background-size: 100%;
    position: relative;
    background-image: url(../../images/future-park/bg-myparking.svg);
    background-size: cover;
    background-position: center;
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        display: flex;
        span {
            margin-left: 10px;
            color: ${(props) =>
                props?.themePageColor !== "" ? `${props?.themePageColor}` : "#fff"};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .wrapper-myparking {
        .set-content {
            padding: 0 32px;
        }
        .show-tier-myparking {
            padding: 0px 32px;
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-bottom: 30px;
            .my-tier {
                display: flex;
                justify-content: flex-start;
                align-items: center;
                gap: 10px;
                span {
                    color: #a2a2a1;
                    font-size: 16px;
                    line-height: 19px;
                    font-weight: 600;
                }
            }
        }
        .layout-carcard-myparking {
            padding: 0 32px;
            .title-carcard-myparking {
                font-size: 14px;
                line-height: 20px;
                color: rgb(255, 255, 255);
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 10px;
                margin-bottom: 10px;
                .group-title {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    gap: 10px;
                }
                .text-addcar-myparking {
                    color: #cad51c;
                    font-size: 14px;
                    line-height: 20px;
                }
                span {
                    img {
                        width: 31px;
                    }
                }
            }
            .add-carcard-myparking-vip {
                border-radius: 8px;
                border: 1px dashed #e3c850;
                background: rgba(227, 200, 80, 0.32);
                display: flex;
                padding: 62.5px 0px;
                justify-content: center;
                align-items: center;
                gap: 20px;
                align-self: stretch;
                color: #fff;
                margin-bottom: 16px;
            }
            .add-carcard-myparking-general {
                border-radius: 8px;
                border: 1px dashed #ffffff;
                background: rgba(255, 255, 255, 0.32);
                display: flex;
                padding: 62.5px 0px;
                justify-content: center;
                align-items: center;
                gap: 20px;
                align-self: stretch;
                color: #fff;
                margin-bottom: 16px;
            }
            .inactive-card {
                background-image: url(../../images/future-park/bg-inactive-card.svg) !important;
                .id-card-myparking {
                    color: #9b9b9b !important;
                }
                .brand-carcard-myparking {
                    color: rgb(113, 113, 113) !important;
                }
            }
            .vip-card {
                background-image: url(../../images/future-park/bg-vip-card.svg) !important;
                .id-card-myparking {
                    color: #9d7234 !important;
                }
                .brand-carcard-myparking {
                    color: #9d7234 !important;
                }
            }
            .static-card-myparking {
                padding: 8px 8px 14px 16px;
                min-height: 152px;
                border-radius: 12px;
                background-image: url(../../images/future-park/bg-static-card.svg);
                background-size: cover;
                background-repeat: no-repeat;
                margin-bottom: 10px;
                position: relative;
                .id-card-myparking {
                    color: #c5ce29;
                    font-size: 36px;
                    font-weight: 600;
                }
                .province-card-myparking {
                    // color: #C5CE29;
                    color: #9d7234;
                    font-size: 12px;
                    font-weight: 300;
                }
                .brand-carcard-myparking {
                    color: #c5ce29;
                    font-size: 10px;
                    font-weight: 500;
                    font-style: italic;
                    position: absolute;
                    left: 16px;
                    bottom: 14px;
                    span {
                        font-style: normal;
                        display: block;
                    }
                }
                .icon-parking {
                    position: absolute;
                    right: 8px;
                    bottom: 14px;
                }
                .bubble-inactive-card {
                    width: 80px;
                    position: absolute;
                    right: 20px;
                    top: 20px;
                    img {
                        width: 100%;
                    }
                }
                .textqrcode-card-myparking {
                    width: 60px;
                    height: 16px;
                    position: absolute;
                    right: 40px;
                    top: 20px;
                    img {
                        width: 100%;
                    }
                }
                .qrcode-card-myparking {
                    width: 42px;
                    height: 42px;
                    position: absolute;
                    right: 8px;
                    top: 8px;
                    img {
                        width: 100%;
                    }
                }
            }
        }
        .control-btn {
            text-align: center;
            margin-bottom: 30px;
        }
    }
`;

const StyledStatus = styled.div<{ active: boolean }>`
    padding: 4px 6px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: var(--4-px, 4px);
    border-radius: 63px;
    background: ${(props) => (props.active ? "" : "#454545;")};
    font-size: var(--12-px, 12px) !important;
    font-weight: 500;
`;
